import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivateEmailStates } from 'src/app/constants/app.constants';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-activate-email',
  templateUrl: './activate-email.component.html'
})
export class ActivateEmailComponent implements OnInit {

  public activationEmailState = ActivateEmailStates.OngoingActivation;
  public ActivateEmailStates = ActivateEmailStates;
  public isBrowser: boolean;
  public failedActivationText: string;
  public failedActivationLoginButtonText: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _authManagerService: AuthManagerService,
    private _router: Router,
    private _configService: ConfigService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.failedActivationText = this._configService
      .getTextFromKey('email-activation-failed-text')
      .replace('{companyPhoneNumber}', this._configService.getTextFromKey('company-phone-number'));
    this.failedActivationLoginButtonText = this._configService.getTextFromKey('email-activation-failed-login-button-text');
  }
  
  private validateAndActivateEmail(queryParams) {

    if (!queryParams || (queryParams && !queryParams.emailAddress) || (queryParams && !queryParams.evc)) {
      this.activationEmailState = ActivateEmailStates.FailedActivation;
      return;
    }
    
    this._authManagerService.activateEmail({
      emailAddress: queryParams.emailAddress,
      emailVerificationCode: queryParams.evc
    }).subscribe({
      next: () => {
        this.activationEmailState = ActivateEmailStates.Activated;
        this._router.navigate(['/account/owner-details']);
      },
      error: (err) => {
        this.activationEmailState = ActivateEmailStates.FailedActivation;
        console.error('Error activating email:', err);
      }
    });
  }

  ngOnInit() {
    if (!this.isBrowser) return;
    const queryParams = this._activatedRoute.snapshot.queryParams;
    this.validateAndActivateEmail(queryParams);
  }
}
